//计量单位词：个、只、套 用英文怎么翻译？https://zhidao.baidu.com/question/591341634.html
export default {
	languageTxt: 'en_US',
	operationBox: {
		dropdownName: 'Other functions',
		offOn: 'Toggle Light',
		brightness2: 'Dimming',
		changelnglat: 'Set position',
		changelnglat2: 'Manual adjustment',
		loopControl: 'Loop control'
	},
	setNumAbbrFun: {
		hundred: ' hundred',
		thousand: ' thousand',
		tenthousand: ' ten thousand',
		Lakh: ' Lakh',
		million: ' million',
		tenmillion: ' ten million'
	},
	unit: {
		pcs: 'PCS',
		pcs2: 'PCS'
	},
	cron:{
		expressionParseError:"Expression parse error"
	},
	citySplit: 'province',
	all: 'all',
	magStyle: {
		right: 'White background original style',
		black: 'Dark style'
	},
	tgEver:{
		timeEver: "Forever",
		timeNoEver: 'Cancel forever',
		timeEverPlaceholder: 'Time is Permanent',
		timeNoEverPlaceholder: 'Select Date and Time'
	},
	SystemName: 'Lighting System',
	userLogin: "User login",
	SecretKey: 'SK Authentication',
	logOut: 'Exit the system',
	goToIndex: 'Go to index',
	tag: {
		onLine: "on-line",
		offLine: "off-line",
		success: "Success",
		fail: "failed",
		normal: "normal",
		cancel: "logout",
		emergency: "exigency",
		ceneral: "general",
		updata: 'Upgrading',
		failUpdata: 'Upgrade failed',
		serious: 'serious warning',
		major: 'major warning',
		normalWarn: 'normal warning',
		eliminated: 'Eliminated',
		notEliminated: 'Not Eliminated',
		ignore: 'ignore',
		transformWork: 'transform into work order',
		open: "open",
		close: 'close',
		enable: 'Enable',
		disable: 'Deactivate',
		disable1: "Disable",
		runOnce:'Run once',
	},
	tableColumn: {
		index: 'Number',
		id: 'id',
		devicesName: 'name',
		devicesName2: 'Device Name',
		productName: 'Product Name',
		MountChannelNumber: 'Mount channel number',
		RegistrationResults: 'Registration results',
		categoryName: 'Classification name',
		devicesRegisterTime: 'Device registration time',
		updateTime: 'Update Time',
		createTime: 'Creation time',
		devicesId: 'Device ID',
		onlineStatus: 'Status',
		hkIp: 'IP (Domain) Port',
		account: "Account",
		pwd: 'Password',
		hkJwd: 'Latitude and Longitude',
		nvr: "Mounted NVR",
		hkChannel: "Channel Number",
		name: 'Name',
		rt: 'Running',
		wv: 'Voltage',
		i: 'Current',
		z: 'Main',
		f: 'Deputy',
		p: 'Power',
		e: 'Electricity',
		l: 'Brightness',
		s: 'Color Temp',
		time: 'Duration',
		hardWare: 'Hardware version',
		softWare: 'Software version',
		tmDate: 'Device Clock',
		wlid: 'Network ID',
		message: 'Execution result',
		powerOnTime: 'Device power on time',
		fs: 'Sub lamp color Temp',
		zs: 'Main light color Temp',
		fl: 'Secondary light brightness',
		zl: 'Main light brightness',
		fe: 'Auxiliary light electrical energy',
		ze: 'Main light electrical energy',
		fp: 'Sub lamp power',
		zp: 'Main light power',
		fi: 'Auxiliary light current',
		zi: 'Main light current',
		rs: 'RSSI',
		tp: 'Temp',
		ld: 'Linkage brightness',
		keepTime: 'Delay in minutes',
		times: 'Times',
		enable: 'enable',
		keepTime: 'Hold minute',
		aboTimes: 'Absolute time stamp',
		nickname: 'nickname',
		username: 'user name',
		operation: 'operate',
		sxdy: 'voltage',
		sxdl: 'current',
		sxgl: 'power',
		sxdn: 'electricity',
		longitude: 'lng',
		latitude: 'lat',
		assetName: 'Lamp pole name',
		mountDevicesId: 'Mount device',
		lightType: 'Lighting type',
		sumEnergy: 'energy consumption',
		group: 'Device Group Number',
		lkg: " Operation Switch",
		moveTarget: "Movement goal",
		dc: "Detection Capability",
		rai: "Jamming resistance",
		radarConfig: "Radar Config",
		aic: "AI Vision Config",
		pgn: 'Upper',
		tgn: 'Lower',
		ras: 'Sensitivity',
		rcd: 'Direction',
		riar: 'Angle',
		rai: 'Anti-jamming',
		rtd1: 'Distance 1',
		rtd2: 'Distance 2',
		rtd3: 'Distance 3',
		rts1: 'Sensitivity 1',
		rts2: 'Sensitivity 2',
		rts3: 'Sensitivity 3',
	},
	request: {
		AlarmInfoOperationData: {
			0: 'Device ',
			1: ' has no latitude or longitude'
		},
		limitSize: 'The requested data size exceeds the allowed 5M limit and cannot be verified for duplicate submission.',
		intervalError: 'Data is being processed, please do not resubmit',
		download: {
			Loading: 'Downloading data, please wait',
			zipError: 'There was an error downloading the file. Please contact the administrator!'
		},
		errorCode401Fun: {
			content: 'The login status has expired. You can continue to stay on this page or log in again',
			confirmButtonText: 'Login Again',
			passwordError: 'The username or password is incorrect. Please log in again.',
			NetworkError: 'Backend interface connection exception',
			timeout: 'System interface request timeout',
			RequestErrorbefore: 'System Interface',
			RequestErrorafter: 'Exception',



		},
	},
	FormC: {
		edit: 'Edit',
		add: 'New',
		search: 'Search',
		reset: 'Reset',
		noData: 'no data',
		dellMore: 'Batch deletion',
		ElMessageBox: {
			tips: 'System prompt',
			titleEnd: '?',
			disableTip: 'Are you sure you want to disable it?',
			oneRunTip:'Are you sure you want to run it once?',
			enableTip: 'Are you sure you want to enable it?',
			offTip: 'Are you sure you want to stop using it?',
			cancelTip: 'Are you sure you want to cancel the strategy?',
			isModeTip: 'Are you sure you want to execute the scenario?',
			title: 'Are you sure you want to delete it?',
			title2: 'Are you sure you want to delete in bulk?',
			title3: 'Please select the data to be deleted in bulk',
			title4: 'Please select a province, city, or town',
			title5: 'Super user is unable to access this page. Click OK to return to the user management page',
			title6: 'Are you sure you want to clear the log?',
			title7: 'Are you sure you want to restart?',
			title8: 'Are you sure you want to reset?',
			title9: 'Please select the data to be processed！',
			title10: 'The number of alarms cannot exceed 20',
			titleUser: 'Please select a user before proceeding with the operation',
			titleExport: 'Please select the data to export',
			titleSearch: 'Please enter and search again',
			error: 'Delete failed, please contact the administrator.',
			repeated: "The request is ongoing. Please do not submit repeatedly!",
		},
		schedule:"Please select to modify the schedule in bulk.",
		avatarUploader: {
			loading: 'Uploading...',
			title: 'App Icon',
			title2: 'Please click to upload',
			text: 'Only supports images up to 2MB in size',
			error: 'The uploaded image cannot be larger than 2MB!'
		},
		del: 'Delete',
		Close: 'Close',
		cancel: 'Cancel',
		cancel2: 'Canceled',
		operation: 'Operation',
		operation2: 'Group control',
		runOnce:'Run once',
		confirm: 'OK',
		confirm2: 'Confirm',
		sort: 'Sorting',
		return: 'return',
		save: 'save',
		placeholder: 'Please select',
		placeholder2: 'Please select a time',
		placeholder3: 'Enter product number to search',
		placeholder4: 'Device type',
		placeholder5: 'Controls',
		placeholder6: 'Enter device number',
		placeholder7: 'Enter the operand',
		placeholder8: 'Filter operation type',
		placeholder9: 'Screening and sorting',
		placeholderInput: 'Please enter',
		placeholderUpload: 'Please upload',
		placeholderSelect: "Please choose",
		placeholderTimeZone: 'Filter time zones',
		placeholderMax: 'Maximum value',
		placeholderMin: 'Minimum value',
		error: 'Operation failed',
		success: 'Operation successful',
		success2: 'Adjustment successful',
		rules: {
			time: 'Please set the duration',
			size: 'The minimum length is 1 and the maximum is 20',
			ip: 'Please enter IP. Example:127.0.0.1',
			ip2: 'IP type error, please re-enter. Example:127.0.0.1'
		},
		inputDefPlaceholder: 'Please enter',
		Uploader: 'Upload file:',
		pWorkStatus: "Work order status",
		pWorkName: "Work order name",
	},
	login: {
		left: {
			LampControl: 'Luminaire Control',
			DistributionCabinet: 'Power Distribution Cabinet',

		},
		form: {
			username: 'Username：',
			password: 'Password：',
			rememberMe: 'Remember Password',
			Login: 'Login',
			record: '粤ICP备2021129348号'
		},
		rules: {
			username: 'Please fill in your username',
			password: 'Please fill in the password'
		},
		autoLogin: {
			title: 'Login Alert',
			loginFail: 'Auto login failed, please login again',
			signFail: 'Signature verification failed, please get a new login link',
			confirm: 'OK'
		}
	},
	index: {
		header: {
			sunrise: 'sunrise：',
			sunset: 'sunset：',
			enterSys: 'backstage',
			selectProject: 'application',
			user: 'U-mgmt',
			regShowFun: 'View operation results',
			regShowBox: 'Operation result',
			regShowBoxOptionBox: 'View details',
			json: {
				lightSource: 'Light control',
				lightSource2: 'light source',
				DistributionCabinet: 'Power Distribution Cabinet',
				LampPost: 'Light pole',

			}
		},
		guangyuanOptionBox: {
			title: 'Batch on/off lights',
			label: 'Group Name:'
		},
		deviceInfo: {
			totalName: 'Device Quantity',
			json: {
				on: 'ON',
				off: 'OFF',
				lightOnOffTime: 'Luminaire ON/OFF Time',
				lightOnRate: 'Luminaire Working Tendency Chart',
				onlineRate: 'Online Rate',
				offlineRate: 'Offline Rate',
				onlineCount: 'Number of online',
				offlineCount: 'Offline number',
				leakageMonitoring: 'Leak Detect'
			}
		},
		ruleStrategy: {
			TitleH2: 'Strategy List',
			on: 'Activation',
			off: 'Deactivate',
			cancel: 'Cancellation strategy',
			status: 'Modify the status',
			retry: 'Retry',
			message: 'View the message',
			name: 'Change the name',
		},
		alarmInfo: {
			TitleH2: {
				0: 'Alarm name',
				1: 'Alarm Severity',
				2: 'Alarm List',
				3: 'Worksheet'
			},
			table: {
				warningName: 'name',
				warningLevel: 'grade',
				updateTime: 'time',
				warningStatus: 'state',
				option: 'operate',
				error: 'Please select the lamp post from the middle menu bar and locate it to the alarm device',
				error2: 'Error in alarm information, please contact the administrator',
				errorDenggan: 'This alarm is for the Light pole,Please select the lamp post from the middle menu bar and locate it to the alarm device',
				errorPdg: 'This alarm is for the Power Distribution Cabinet,Please select the Power Distribution Cabinet from the middle menu bar and locate it to the alarm device',
				noArea: 'The address of this device has not been set yet'
			},
			json: {
				shebei: 'Device Type',
				yunwei: 'Operation Maintenance',
				nenghao: 'Energy Consumption',
				yiban: 'Regular Alarm',
				jiaoda: 'Minor Alarm',
				yanzhong: 'Major Alarm',
				normal: 'Good'
			}
		},
		workOrderInfo: {
			lightOnOffTimeUndefined: 'No data available',
			lightOnRate1: {
				0: 'Not disposed of',
				1: 'Disposed of'
			},
			lightOnRate2: {
				0: 'Pending approval',
				1: 'Under repair',
				2: 'Pending order',
				3: 'Verified',
				4: 'over',
			},
			lightOnOffTime: 'Worksheet Classification',
			lightOnRate: 'Worksheet Disposal Rate'
		},
		log: {
			sys: 'System log',
			device: 'Device log'
		},
		bottom: {
			btnBox: 'Energy Consumption Tendency Chart',
			typeArr: {
				1: 'Last days',
				2: 'Last month',
				3: 'Last year',
			},
			setData: {
				localEnergy: 'Current Energy Consumption',
				sumEnergy: 'Total Energy Consumption',
				weekEnergy: 'Weekly Energy Consumption',
				monthEnergy: 'Monthly Energy Consumption',
				yearEnergy: 'Annual Energy Consumption',
				last7DaysEsr: "Weekly Energy Efficiency"
			},
			echart: {
				energyChart: "Energy Chart",
				energy: "Energy",
				energySave: "Energy-saving",
				energyData: "Energy Data"
			}
		},
		baiduMap: {
			totalNumMarkerArrShowFun2: 'Return to the total device count view',
			backAreaCenterTooltip: {
				0: 'Return to the center of the ',
				1: ''
			},
			viewMarkerItem: {
				0: 'View devices in the ',
				1: ' '
			},
			expandMapFun: {
				0: 'Expand View',
				1: 'Restore View'
			},
			heatmapShow: {
				0: 'show heatmap',
				1: 'hide heatmap'
			},
			AlarmInfoOperationDataNull: 'Device information error, please contact administrator.',
			viewMarkerItemUndefined: 'Device positioning error, please reset it in the background management.',
			noCityOrErea: 'No Select a province or city, please select first！',
			searchBox: {
				placeholder: 'Please enter the device ID'
			},
			ztList: {
				sxdy: 'Three phase voltage:',
				sxdl: 'Three phase current:',
				sxgl: 'Three phase power:',
				sxdn: 'Three phase electrical energy:',
				height: 'Height:',
				weight: ', Width:',
				length: ', Length:',
				0: 'Offline',
				1: 'Online',
				2: 'Upgrading',
				3: 'Upgrade Failed',
				wv: 'Working voltage:',
				wvUnit: 'V，',
				sl1: {
					zl: 'Brightness:',
					zs: 'Color temperature:',
					zi: 'Working current:',
					ziUnit: 'A',
					ze: '， Working energy consumption:',
					zeUnit: 'KW'
				},
				sl2: {
					zl: 'Main light brightness:',
					fl: ', Secondary light brightness:',
					zs: 'Main light color temperature:',
					fs: ', color temperature of auxiliary lights:',
					zi: 'Main light working current:',
					fi: '， Secondary lamp working current:',
					ze: '， Main light working energy consumption:',
					fe: '， Secondary light working energy consumption:'
				}
			},
			operationBox: {
				zl: 'Main brightness',
				fl: 'Sub brightness',
				l: 'Brightness',
				zs: 'Main color temperature',
				fs: 'Sub color temperature',
				s: 'Color temperature',
				time: {
					error1: 'Please select the minimum time after two minutes',
					error2: 'Please select within 45 days',
					error3: 'Please select the minimum time after one minute',
					error4:'Please select a time that is later than the current time'
				},
				sl2: {
					0: 'Main',
					1: 'Sub'
				},
				minute: 'Minute',
				offOnSwitch: {
					0: 'OFF',
					1: 'ON'
				}
			},
			contentBox: {
				denggan: 'Light pole details',
				Alarm: 'Alarm details',
				deviceId: 'Name of light control equipment',
				deviceIds: 'Select device dimming'
			},
			alarmCheckbox: {
				title: 'Alarm Level'
			},
			json: {
				markerArrInfoList: {
					installPosition: 'Location',
					attributes: 'Properties',
					attributes2: 'Voltage and current',
					denggan: {
						name: 'Lamp Pole Name',
						num: 'Number of lighting control devices mounted on the lamp post',
						id: 'Lamp post ID',
						time: 'Creation time'
					},
					AlarmInfo: {
						name: 'Device Name',
						id: 'Device ID',
						time: 'Alarm time',
						state: 'Alarm state',
						chaoshi: 'Does the alarm time out?',
						type: 'Alarm type',
						email: 'Alarm push email'
					}
				}
			}
		},
		selectProject: {
			add: 'Create an application',
			title: 'Switch applications',
			Search: 'Enter keywords to search for applications',
			loadEnd: "It's already ended",
			GIS: 'GIS:',
			createTime: 'createTime:',
			appName: 'apply name',
			appNameRule: 'Please fill in the application name',
			provinceCity: 'GIS',
			provinceCityRule: 'Please select GIS'
		}
	},
	mag: {
		router: {
			assetindex: 'Asset Management',
			assetview: 'View asset grouping',
			deviceinfoTitle: 'Device Management',
			deviceinfo: 'device info details',
			devicegroupMag: 'group management',
			devicegroupMagview: 'group management details',
			alarmindex: 'Alarm Worksheet',
			ruleStrategyindex: 'Rule & Strategy',
			ruleStrategyInfo: 'Strategy Management',
			ruleStrategyInfoV: 'Strategy Management Editor',
			ruleStrategyGroupV: 'Strategy equipment grouping settings',
			deviceRecord: "Equipment data recording",
			ruleStrategyGroup: 'Policy Group Mgmt',
			logindex: 'Log',
			deviceController: 'Device Control',
			user: 'User Management',
			third: '3rd-Party Accounts',
			media: 'Media Library',
			deviceSearch: 'Device search',
			deviceTotal: 'Equipment statistics',
			communication: 'Communication management',
			Setting: 'Setting',
			energy: 'Energy statistics',
			activity: 'Activity report',
			workinfoTitle: 'Order manage',
			worktransfer: 'Alert to Ticket',
			workinfo: 'My Creations',
			workHandle: 'My Tasks',
			workHistory: 'Handling History',
			sim: 'sim card information',
			scene: 'Scene Light Ctrl',
			configuration: 'Scene Preset Config',
			mode: 'Scene Mode',
			deviceinfoS: 'Device',
			devicegroupMagS: 'Groups',
			SettingS: 'Config',
			energyS: 'Energy',
			activityS: 'Activity',
			simS: 'SIM',
			sceneS: 'Scenes',
			worktransferS: 'Transfer',
			workinfoS: 'Create',
			workHandleS: 'Process',
			workHistoryS: 'History',
			logindexS: 'Logs',
			userS: 'Users',
			thirdS: 'third',
			ruleStrategyInfoS: 'Strategy',
			ruleStrategyGroupS: 'Groups',
			task: "Inspection Task",
			taskRecord: "Inspection Record",
			taskS: "Task",
			taskRecordS: "Record",
			lightRate:'Lighting Rate',
			lightRateS:'Light Rate',
		},
		components: {
			tableBox: {
				description: 'Loading',
				option: 'operation',
				edit: 'Edit',
				del: 'Delete',
				view: 'Detail',
				handle: 'Handle',
				delSuccess: 'Delete successful!',
				delError: 'Delete failed, please contact the administrator',
				pagination: {
					pagesize: "Pcs/Page",
					total: "Total:",
					pageClassifier: "Jump",
				}
			},
			addEditDrawer: {
				edit: 'Edit',
				addSuccess: 'Add',
				success: ' success!',
				clone: 'Clone',
				error: 'Add failed, please contact the administrator',
				authority: 'Please select application permissions！'
			},
			searchBox: {
				add: 'Add'
			},
			searchDiv: {
				searchPlaceholder: 'Search',
				PopoverBox: {
					title: 'Advanced Search'
				}
			},
			leftTree: {
				title: 'Device Tree',
				placeholder: 'Please enter keywords for search'
			}
		},
		tabsList: {
			Light: 'Lamp control',
			Pole: 'Pole',
			Ggd: 'Ggd',
			jcqnb: 'Contactor chronology',
			tgnb: 'Dimming time table configuration',
			lightTypeMag: 'Lighting type'
		},
		alarm: {
			tabsList: {
				warning: 'Alarm',
				workOrder: 'Work Order'
			},
			btnList: {
				add: 'Create Work Order'
			},
			tableColumn: {
				id: 'Alarm ID',
				warningName: 'Alarm name',
				devicesId: 'Device ID',
				warningType: 'Alarm Type',
				warningLevel: 'Alarm level',
				warningStatus: 'Alarm state',
				warningDeal: 'Alarm disposal',
				updateTime: 'Update Time'
			},
			tableColumn2: {
				warningIds: 'Alarm ID',
				name: 'Work Order Name',
				warningNames: 'Name of associated alarm',
				responsiblePerson: 'Work Order Dispatch List',
				responsibleEmail: 'Work Order Dispatch Email',
				workStatus: 'Work Order Processing Status',
				updateTime: 'Update Time'
			},
			addEditDrawer: {
				warningDealId: 'Alarm disposal:',
				rules: {
					warningDealId: 'Please select alarm disposal'
				}
			},
			addEditDrawer2: {
				warningIds: 'Alarm name:',
				name: 'Work Order Name:',
				category: 'Work Order Classification:',
				responsiblePerson: 'Work Order Dispatch List:',
				responsibleEmail: 'Work Order Assignment Email:',
				workStatus: 'Work order processing status:',
				rules: {
					workStatus: 'Please select work order processing status',
					warningIds: 'Please select alarm name',
					category: 'Please select work order category',
					name: 'Please fill in work order name',
					responsiblePerson: 'Please fill in the work order dispatch list',
					responsibleEmail: 'Please fill in the work order dispatch email',

				}
			}
		},
		asset: {
			tableColumn: {
				name: 'Name of asset group',
				companyName: 'Company Name',
				assetLightPoleCount: 'Number of poles',
				assetLightCount: 'Number of light controls',
				assetGgdCount: 'Number of ggd',
				updateTime: 'Update Time'
			},
			addEditDrawer: {
				name: 'Name of asset group:',
				companyName: 'Company Name:',
				groupIds: 'Select group:',
				rules: {
					name: 'Please fill in asset portfolio name',
					companyName: 'Please fill in the unit',

				},
			},
			view: {

				tableColumn: {
					name: {
						Ggd: 'Ggd name',
						Pole: 'Pole name',
						Light: 'Lamp control name'
					},
					deviceId: 'Device ID',
					installPosition: 'Installation position',
					installTime: 'Installation time',
					height: 'height',
					weight: 'width',
					longitude: 'longitude',
					latitude: 'latitude',
					updateTime: 'Update Time',
					material: 'material',
					poleType: 'Pole type',
					armType: 'Lamp arm type',
					lightPoleName: 'Pole name',
					lampCapType: 'Light source type',
					lampCapCount: 'Light source count',
					assetGgdName: 'Affiliation ggd'


				},
				addEditDrawer: {
					deviceId: 'device:',
					hlbh: 'Loop number',
					hlkg: 'Loop switch',
					name: {
						Ggd: 'Ggd name:',
						Pole: 'Pole name:',
						Light: 'Lamp control name:'
					},
					assetGgdId: 'Ggd：',
					provinceCityArea: 'Select provinces and cities (towns):',
					installPosition: 'Installation location:',
					installTime: 'Installation time:',
					height: 'height:',
					weight: ' weight:',
					longitude: 'longitude:',
					latitude: 'latitude:',
					material: 'material:',
					poleType: 'pole type:',
					armType: 'Lamp arm type:',
					lightPoleId: 'Pole:',
					lampCapType: 'Light source type:',
					lampCapCount: 'Light source count:',
					rules: {
						deviceId: 'Please select device',
						name: {
							Ggd: 'Please fill in the name of power distribution cabinet',
							Pole: 'Please fill in the lamp post name',
							Light: 'Please fill in the name of Lamp control'
						},
					}
				}
			}
		},
		device: {
			LOnline:'Number of online light controllers	',
			LOffline:'Number of offline light controllers',
			COnline:'Number of online concentrators',
			COffline:'Number of offline concentrators',
			tai:'Unit',
			info: {
				searchPlaceholder: 'Please enter device ID',
				btnList: {
					energyReplace: 'Power Inheritance',
					add: 'Single device registration',
					addMore: 'Batch registration',
					addMore1: 'Hikvision registration',
					addLnglatMore: 'Batch import of latitude and longitude',
					update: 'Device Upgrade',
					export: 'export',
					exportExcel: 'export Excel',
					exportWord: 'export Word',
				},
				tableColumn: {
					devicesId: 'Device ID',
					devicesName: 'Device name',
					regTime: 'Time of registration',
					hardWare: 'Firmware version',
					groupName: 'Group Name',
					productName: 'Product Name',
					categoryName: 'Device classification name',
					onlineStatus: 'Status',
					updateTime: 'update Time',
					timeZone: 'Time zone',
				},
				addEditDrawer: {
					devicesId: 'Device ID:',
					devicesName: 'Device name:',
					productId: 'Product:',
					groupId: 'Device grouping:',
					groupIdaddOption: {
						0: 'Ungrouped'
					},
					categoryId: 'Classification:',
					mountDevicesId: 'Mount concentrator:',
					mountDevicesId1: 'Mount NVR:',
					mountChannel: 'Channel',
					onlineStatus: 'Online status:',
					devicesRegisterTime: 'Device registration time:',
					softWare: 'Software version:',
					hardWare: 'Hardware version:',
					cid: 'Communication card number:',
					timeZone: 'Time zone:',
					imei: 'Device IMEI:',
					rules: {
						devicesId: 'Please fill in the device number',
						devicesName: 'Please fill in the device name',
						productId: 'Please select a product',
						categoryId: 'Please select a category'
					}
				},
				editBoxData: {
					sourceDeviceId: 'Source Device ID',
					targetDeviceId: 'Target Device ID',
					rules: {
						deviceRegular: 'Invalid Device ID Format',
					}
				},
				upDate: {
					upload__text: {
						0: 'Drag files here or',
						1: 'Click to upload'
					},
					uploading: 'Uploading',
					uploadSuccessList: {
						firmwareName: 'Firmware Name:'
					},
					confirm: 'upgrade',
					success: 'Operation successful, upgrading in progress.',
					uploadSuccessList0: 'Please upload the firmware file',
					uploadSuccessList1: 'Uploaded to the firmware file',
					formItem: {
						productId: 'Product:',
						groupId: 'Device:',
						retryNum: "Retry count",
						delayLevel: "Timeout period",
						subSize: "Subcontract size",
						retryNumTip: "The retry count is 0-5",
						retryNumRule: "The number of restarts is 0 to 5"
					},
					tableColumn: {
						devicesId: 'Device ID',
						devicesName: 'Device Name',
						hardWare: 'Firmware version',
						groupName: 'Group Name'
					}
				},
				addMore: {
					modelDown: 'Template download',
					loadFile: 'Load file',
					register: 'Click to register',
					success: 'registered successfully：',
					error: 'other：',
					deviceErrTip: 'The format of the device ID is incorrect, please check before uploading!',
					emptyLine: 'The device ids of these rows do not exist',
					batchRegErr: 'Registration failure：',
					uploadSuccessBox: {
						uploadSuccessList: {
							title: 'registered successfully',
							title2: 'Successful import of latitude and longitude:',
							num: 'Device number:'
						},
						uploadErrorList: {
							title: 'Registration failed:',
							title2: 'Longitude and latitude import failed:',
						}
					}
				}
			},
			groupMag: {
				tableColumn: {
					groupName: 'Group Name',
					productName: 'Product Name',
					status: 'status',
					updateTime: 'Update Time',
					assetSumName: 'Asset group to which it belongs'
				},
				btnList: {
					add: 'Add group'
				},
				addEditDrawer: {
					groupName: 'Group name:',
					productId: 'Product:',
					status: 'Status:',
					assetSumId: 'Asset grouping',
					rules: {
						groupName: 'Please fill in the group name',
						assetSumId: 'Please select asset grouping',
						productId: 'Please select a product',
					}
				},
				view: {
					selection0: 'Please select device operation',
					TableBox: {
						add: 'Add grouping configuration',
						del: 'Cancel grouping configuration'
					},
					btnList: {
						editDevicesGroup: 'Batch group devices',
						editDevicesGroupOut: 'Batch Remove Device'
					},
					PopoverformItem: {
						productId: 'Product:',
						productIdaddOption: {
							0: 'all'
						},
						categoryId: 'Classification:',
						assetSumId: 'Asset grouping:'
					},
					tableColumn: {
						devicesId: 'Device ID',
						devicesName: 'Device Name',
						productName: 'Product Name',
						categoryName: 'Device type name',
						updateTime: 'Device storage time'
					}
				}
			},
			setting: {
				last: "Last month",
				todey: "Today",
				next: 'Next month',
				batch: 'Batch Edit Schedule',
				enSet: 'Energy Settings',
				basePower: 'Base Power',
				totalPower: 'Total Power(KWh)',
				ennualEnergy: 'Annual Energy',
				usageHours: 'Usage Hours(h)',
				dailyEnergy: 'Daily Energy',
				deviceSumKWh: "Baseline Electricity(KWh)",
				deviceKWh: "Baseline Electricity"
			},
			
		},
		scene: {
			configuration: {
				disable: 'Disable',
				enable: 'Enable',
				disableTip: 'Are you sure you want to disable it?',
				enableTip: 'Are you sure you want to enable it?',
				name: "Configuration name",
				type: "Product type",
				instruct: "Instruction",
				parameter: "Dynamic parameters",
				creator: "creator",
				upDataTime: "Update time",
				status: "Status",
				addTitle: 'New configuration'
			},
			mode: {
				name: "Scene name",
				scene: "Execution scenario",
				type: "Pattern type",
				deviceType: 'Device type',
				config: "Product configuration",
				creator: "creator",
				upDataTime: "Update time",
				addTitle: 'New scenarios'
			}
		},
		activity: {
			btnList: {
				exportExcel: 'export Excel',
				exportWord: 'export Word'
			},
			exportWord: {
				timeConfig: 'Time allocation：',
				deviceId: 'Equipment number：',
				deviceGroupId: 'Device grouping：',
			},
			// exportExcel: {
			// 	wv: 'Max and min operating voltage：',
			// 	zi: 'Max and min working current of the main lamp：',
			// 	fi: 'Max and min operating current of the auxiliary lamp：',
			// 	zp: 'Maxand minactive power of the main lamp：',
			// 	fp: 'Max and min active power of the auxiliary lamp：',
			// 	wvMin: 'Minimum operating voltage',
			// 	wvMax: 'Maximum operating voltage',
			// 	ziMax: 'Maximum working current of the main lamp',
			// 	ziMin: 'Minimum working current of the main lamp',
			// 	fiMax: 'Maximum operating current of the auxiliary lamp',
			// 	fiMin: 'Minimum working current of the auxiliary lamp',
			// 	zpMax: 'Maximum active power of the main lamp',
			// 	zpMin: 'Minimum active power of the main lamp',
			// 	fpMax: 'The maximum power of the auxiliary lamp',
			// 	fpMin: 'The minimum power of the auxiliary lamp',
			// 	tg: 'Dimming',
			// 	maxMin: 'Maximum and minimum',
			// 	hl: 'loop',
			// 	max:'Maximum',
			// 	min:'minimum',
			// 	hl:'loop',
			// 	minDim1: "Minimum dimming value 1",
			// 	minDim2: "Minimum dimming value 2", 
			// 	minDim3: "Minimum dimming value 3",
			// 	minDim4: "Minimum dimming value 4",
			// 	minDim5: "Minimum dimming value 5",
			// 	minDim6: "Minimum dimming value 6",
			// 	minDim7: "Minimum dimming value 7",
			// 	minDim8: "Minimum dimming value 8",
			// 	maxDim1: "Maximum dimming value 1",
			// 	maxDim2: "Maximum dimming value 2",
			// 	maxDim3: "Maximum dimming value 3",
			// 	maxDim4: "Maximum dimming value 4",
			// 	maxDim5: "Maximum dimming value 5",
			// 	maxDim6: "Maximum dimming value 6",
			// 	maxDim7: "Maximum dimming value 7",
			// 	maxDim8: "Maximum dimming value 8"
			// },
			exportExcel: {
				wvMin: 'Minimum operating voltage',
				wvMax: 'Maximum operating voltage',
				ziMax: 'Maximum working current of the main lamp',
				ziMin: 'Minimum working current of the main lamp',
				fiMax: 'Maximum operating current of the auxiliary lamp',
				fiMin: 'Minimum working current of the auxiliary lamp',
				zpMax: 'Maximum active power of the main lamp',
				zpMin: 'Minimum active power of the main lamp',
				fpMax: 'The maximum power of the auxiliary lamp',
				fpMin: 'The minimum power of the auxiliary lamp',
				wv: 'Max and min operating voltage：',
				zi: 'Max and min working current of the main lamp：',
				fi: 'Max and min operating current of the auxiliary lamp：',
				zp: 'Maxand minactive power of the main lamp：',
				fp: 'Max and min active power of the auxiliary lamp：',
				tg: 'Dimming',
				maxMin: ' Maximum and minimum',
				max: 'Maximum',
				hl: 'minimum',
				hl: 'loop',
				minDim1: "Maximum1 Min",
				minDim2: "Maximum2 Min",
				minDim3: "Maximum3 Min",
				minDim4: "Maximum4 Min",
				minDim5: "Maximum5 Min",
				minDim6: "Maximum6 Min",
				minDim7: "Maximum7 Min",
				minDim8: "Maximum8 Min",
				maxDim1: 'Maximum1 Max',
				maxDim2: 'Maximum2 Max',
				maxDim3: 'Maximum3 Max',
				maxDim4: 'Maximum4 Max',
				maxDim5: 'Maximum5 Max',
				maxDim6: 'Maximum6 Max',
				maxDim7: 'Maximum7 Max',
				maxDim8: 'Maximum8 Max',
			}
		},
		task: {
		    task: {
		        tableColumn: {
		            taskName: "Task Name",
		            taskType: "Task Type",
		            cronExpr: "Cron Expression",
		            targetType: "Target Type",
		            status: "Task Status",
		            remark: "Remarks",
		            updateByName: "Updater Nickname",
		            updateTime: "Update Time",
		        },
				taskName:"Task Name",
				taskType:"Task Type",
				cronExpr:"Cron Expression",
				targetType:"Target Type",
				targetContent: "Inspection Target Content",
				remark:"Remarks",
		    },
			record:{
				tableColumn:{
				  taskName: "Task Name",
				  execTime: "Execution Time",
				  execStatus: "Execution Status",
				  totalItem: "Total Items",
				  successItem: "Success Count",
				  failItem: "Failure Count",
				  execCost: "Cost (ms)",
				  execWay: "Execution Method",
				  operator: "Operator",
				  createTime: "Create Time"
				},
			},
			fiveRun: "Last 5 Run Times:",
			inspection: "Last Inspection Result:",
			targetId: "Inspection Target",
			targetName: "Inspection Target Name",
			isNormal: "Is Normal",
			errorMsg: "Error Message",
			execCost: "Cost (ms)",
		    total: "Total Count",
		    success: "Success Count",
			completedCount:"Completed count",
		},
		work: {
			rules: {
				name: "Please fill in the name of the ticket",
				alarm: "Select associated alarms",
				priority: "Please select a priority",
				responsiblePerson: 'Please fill in the dispatch list of work order',
				workStatus: 'Please select',
				warningIds: 'Associated alarm'
			},
			detail: {
				workMsg: 'Work order information',
				responsiblePerson: 'Assigned personnel',
				workWarning: "Work order alarm",
				phone: 'cell-phone number',
				smsStatus: 'SMS Status',
				confirmStatus: 'Confirmation Status',
				nickname: 'Designator nickname',
				confirmTime: 'Confirmation time',
				warnId: 'Alarm ID',
				warningName: 'Alarm name',
				devicesId: 'Equipment number',
				warningType: 'Alarm type',
				warningLevel: 'Alarm level',
				initWorkOrder: "Initiating work order",
				processWorkOrder: "Accepted",
				examineWorkOrder: "Time Approval",
				repairSuccess: "Progress Approval",
				verifyResult: "Result Approval",
				process: 'Current process review information',
				user: 'User',
				opinion: 'Approval opinion',
				estimatedFinshTime: 'Estimated maintenance time',
				damageReason: 'Cause of damage',
				repairTimeStatus: "Approval of maintenance time",
				finishStatus: 'Review result',
				comment: 'Audit opinion',
				describe: "describe",
				location: 'Location view',
				initiated: 'Has been initiated',
			},
			info: {
				btnList: {
					add: 'Create Work Order',
					ignore: 'Ignore the alarm'
				},
				tableColumn: {
					name: 'Work Order Name',
					num: 'Number',
					alertName: 'Associated Alert Name',
					alertID: 'Associated Alert ID',
					status: 'Work Order Status',
					creator: 'Creator',
					assignee: 'Assignee',
					createTime: 'createTime',
					priority: 'Priority',
				},
				workID: "Work order number:",
				workName: "Work order name:",
				alarm: "Associated alarm:",
				priority: "priority:",
				responsiblePerson: 'Dispatch list of work order',
				workStatus: 'Whether to initiate',
				comment: 'Audit opinion',
				search: ' Enter the name of the work order',
			},
			handle: {
				tableColumn: {
					num: 'Number',
					name: 'Work Order Name',
					status: 'status',
					type: 'type',
					priority: 'Priority',
					creator: 'Creator',
					assignee: 'Assignee',
					createTime: 'createTime',
					updateTime: 'Update Time',
				},
			},
			history: {
				tableColumn: {
					num: 'Number',
					name: 'Work Order Name',
					type: 'type',
					reason: 'reason',
					priority: 'Priority',
					creator: 'Creator',
					assignee: 'Assignee',
					createTime: 'createTime',
					endTime: 'End time',
				},
			}
		},
		log: {
			tabsList: {
				device: 'Device Log',
				sys: 'system Log'
			},
			tableColumn: {
				devicesId: 'Device ID',
				consumer: 'by Operated object',
				createTime: 'Create Time',
				content: 'Log content',
				deviceGroupName: 'Device group name',
				deviceProductName: 'Equipment product name',
				appName: 'Application name',
				createNickname: 'Creator nickname',
				producerName: 'Device name',
				consumerJson: 'Device message',
				producerJson: 'System message',
				status: 'status'
			},
			btnList: {
				export: 'export',
				clear: 'Clear logs',
				del: 'delete',
				delError: 'Please select a time first'
			},
			formItem: {
				time: 'Time range:',
				type: 'Parameter type:',
				hlTime: 'Holding time',
			}
		},
		ruleStrategy: {
			tabsList: {
				info: 'Strategy information',
				record: 'Equipment control record'
			},
			tableColumn: {
				name: 'Strategy name',
				type: 'Strategy type',
				runUnit: 'Sxecution unit',
				effectTime: 'Start Time',
				invalidTime: 'End Time',
				runTime: 'Execution time',
				targetIdList: 'Device ID',
				status: 'Status'
			},
			addEditDrawer: {
				name: 'Strategy name：',
				status: 'Status：',
				type: 'Strategy type:',
				productId: 'Product:',
				triggerId: 'Trigger:',
				judgmentId: 'Judgment:',
				disposerId: 'Disposer:',
				time: 'Start Time - End Time:',
				runTime: 'Execution time:',
				runUnit: 'Execution unit:',
				targetType: 'Associated target type:',
				targetIdList: 'Related targets:',
				effectEverydayTime: 'Daily effective time period:',
				effectEverydayTime1: 'Group 1:',
				effectEverydayTime2: 'Group 2:',
				rules: {
					name: 'Please fill in the strategy name',
					status: 'Please select a status',
					type: 'Please select the type',
					productId: 'Please select a product',
					triggerId: 'Please select trigger',
					judgmentId: 'Please select the operation rule',
					disposerId: 'Please select a disposer',
					runUnit: 'Please select the execution unit',
					targetType: 'Please select the associated target type',
					targetIdList: 'Please select the associated target',

				}
			},
			btnList: {
				add: 'New Strategy',
				add1: 'New event strategy',
				add2: 'Add timing strategy'
			},
			recordTableColumn: {
				deviceId: 'DeviceId',
				name: 'Name',
				status: 'Status',
				type: 'Type',
				lastSendTime: 'Last Send Time',
			},
			messageTableColumn: {
				devicesId: 'Device ID',
				sendBody: 'Send Message Body',
				responseBody: 'Response Message Body',
				status: 'status',
				type: 'type',
			},
			recordBtnList: {
				refresh: 'Refresh'
			},
		},
		ruleStrategyGroup: {
			tableColumn: {
				groupName: 'Group name',
				name: 'Product Name',
				updateTime: 'Update Time',
			},
			formItem: {
				groupName: 'Group name：',
				product: 'Product：',
				select: 'Equipment selection：',
				group: 'Equipment grouping：',
				groupSelect: 'Please select the group',
			},
		},
		deviceController: {
			camera: {
				actual: 'Live View',
				replay: 'Playback',
				screenshot: 'Screenshot',
				PreviewAll: 'Preview All Now',
				stop: 'Stop',
				play: 'Play',
				allPlay: "Play all",
				streamType: 'Stream Type',
				mainStream: 'Main Stream',
				subStream: 'Sub Stream',
				stopAll: 'Stop All',
				screenSplit: 'Screen Split',
				fullScreen: 'Full Screen',
				page: 'View',
				channel: 'Channel',
				channelTip: "Please set up the channel first！",
				configTip: 'Please set the configuration first！',
				PTZControlTip: 'This device does not support mobility！',
				loginError: 'Login failed！'
			},
			mf: {
				vjl: 'Voltage Measurement Factor',
				zijl: 'Main Light Current Measurement Factor',
				fijl: 'Main Light Power Measurement Factor',
				zpjl: 'Auxiliary Light Current Measurement Factor',
				fpjl: 'Auxiliary Light Power Measurement Factor',
			},
			ggdViewBox: {
				getDDQKGGTG: 'View single lamp group control light perception',
				getDDZR: 'View the group control single light on-time schedule',
				getSxjlxs: 'View measurement coefficient',
				HLZR: 'View Loop On-time Daily Table',
				getDDJR: 'View the group control single light chronograph day watch',
				baseInfo: 'Basic information',
				getTgzr: 'View the dimming on-time day watch',
				getTgnb: 'View the dimming timeline',
				getTgggVO: 'View light sensing Settings',
				getHlfdtg: 'Light Sensing Stepped Dimming',
				getWarnsafe: 'Rain/Snow Alarm Protection',
				hideinfoBox: {
					0: 'Show more',
					1: 'Hide'
				},
				minute: 'min',
				getHlNb: 'View loop chronology',
				JcqStatusListDataTitle: 'Loop state',
				RealTimeData: 'Real-time data',
				AlarmWidth: 'Alarm width',
				flowSensorVO: 'List of vehicle flow sensors',
				illuminantSensorVO: 'List of illumination sensors',
				wloggingSensorVO: 'List of water sensors',
				rainsnowSensorVO:'List of Rain/Snow Sensors',
				poweroffProtectionVO: 'List of power failure protection detection devices',
				ddldggldList: 'Radar and Ambient Light Linkage Mode Settings',
				deviceID: 'Device number',
				deviceName: 'Device name',
				trafficFlow: 'Traffic flow',
				illumination: 'illumination',
				yx:'rain and snow Status',
				water: 'Water flooding',
				offline: 'Power off or not',
				RTC: 'Radar Target Detection',
				433: '433 Communication Module',
				infoLabelList: {
					4: {
						id: 'device ID',
						devicesName: 'Equipment designation',
						onlineStatus: 'Online status',
						sxdn: 'Three phase electrical energy',
						sbxh: 'Equipment model',
						productName: 'Product name',
						mzxh: 'Module Model',
						rtcsj: 'Device time',
						yxsj: 'Run time',
						jwd: 'Latitude and longitude',
						jwdLng: 'Longitude',
						jwdLat: 'Latitude',
						hgqzsb: 'Current transformer turns ratio',
						jzqczkg: 'Concentrator operating switch',
						tgbc: 'Dimming adaptive compensation',
						jwsj: 'Local latitude and longitude time',
						jwpyz: 'Local longitude and latitude time offset value',
						jwpyzT: 'Local latitude and longitude time offset time',
						jwpyzLabel: {
							0: 'sunrise',
							1: 'sunset'
						},
						jcqrbms: 'Loop mode',
						tgrbms: 'Daily pattern',
						ntgv: 'Real-time voltage',
						tglj: 'Dimming logic',
						jcqrbmssortableArrUnit: ' road',
						sxdy: 'Three phase voltage',
						sxdl: 'Three phase current',
						sxgl: 'Three phase electric power',
						sxdlAll: 'Three-phase total current',
						sxdnAll: 'Three-phase total energy',
						sxglAll: 'Three-phase total power',
						wdgjyz: 'Equipment temperature alarm threshold',
						temp: 'Equipment temperature',
						sxdlgjyz: 'Three phase current alarm threshold',
						sxdlgjyzAmin: 'A-phase min',
						sxdlgjyzAmax: 'A-phase max',
						sxdlgjyzBmin: 'B-phase min',
						sxdlgjyzBmax: 'B-phase max',
						sxdlgjyzCmin: 'C-phase min',
						sxdlgjyzCmax: 'C-phase max',
						sxdygjyz: 'Three phase voltage alarm threshold',
						sxgjsn: 'Alarm enabling',
						sxgjsnA: 'A-phase Alarm enabling',
						sxgjsnB: 'B-phaseAlarm enabling',
						sxgjsnC: 'C-phaseAlarm enabling',
						sxgjsnsortableArr: {
							0: 'Voltage alarm enabling',
							1: 'Current alarm enable',
							2: 'Temperature alarm enabled'
						},
						hardWare: 'Hardware version',
						softWare: 'Software version',
						hlggsz: 'Loop light sensing parameters',
						hlggszArr: {
							0: 'brightness',
							1: 'return difference'
						},
						lxkg: 'Polling switch',
						lxzq: 'Polling period',
						sbsjzq: 'Heartbeat cycle',
						gjzq: 'Alarm cycle',
						ddqkrbms: 'Single lamp group control daily meter mode',
						temp: 'Equipment temperature',
						wlid: 'Network ID',
						kglsc: '3 switch output',
						kglsr: 'Three switch inputs',
						ntgz: 'Dimming value',
						dlbh: 'Light control short-circuit protection switch',
						tgdls: 'Short-circuit condition',
						tgmrv: 'Default startup voltage'
					}
				}
			},
			searchPlaceholder: 'Please fill in the device number to search',
			tabsList: {
				Light: "MQTT",
				sys: 'TCP',

			},
			setHlgg: {
				ld: 'Brightness',
				hc: 'Return difference'
			},
			setDdldggld: {
				ldldkg: 'Radar Linkage Switch',
				ldcfldsj: 'Radar Trigger Light Duration(s)',
				ggldkg: 'Light Sensor Linkage Switch',
				mrld: 'Default Brightness',
				mrsw: 'Default Color Temp',
				ldMinld: 'Min Linkage Brightness',
				ldMaxld: 'Max Linkage Brightness	',
			},
			dimTg: {
				tgNums: 'Dimming number',
				tgPercent: 'Dimming value',
				yf: 'month'
			},
			setJwdpyz: {
				rcpyz: 'Sunrise offset value (s)',
				rlpyz: 'Sunset offset value (s)',
				rcld: 'Sunrise brightness',
				rlld: 'Sunset brightness'
			},
			setGJZQ: {
				gjzq: 'Alarm period (minute)'
			},
			setHgqzsb: {
				hgqzsb: 'Current transformer turns ratio'
			},
			setSbsjzq: {
				sbsjzq: 'Beat cycle (s)'
			},
			setLdcs: {
				ldsn: 'Linkage enablement',
				ldys: 'Linkage delay time (seconds)',
				ldcs: 'Linkage timeout (seconds)'
			},
			setJzqczkg: {
				jzqczkg: 'Concentrator operating switch'
			},
			setKglsc: {
				kglsc1: '1 road',
				kglsc2: '2 road',
				kglsc3: '3 road'
			},
			syncHlNb: {
				jcqNum: 'Circuit No',
				jcqyf: 'Month'
			},
			setHlNb: {
				jcqnbId: 'Chronology',
				jcqnbNum: 'Circuit No'
			},
			setHlRm: {
				jcqkg1: '1 road',
				jcqkg2: '2 road',
				jcqkg3: '3 road',
				jcqkg4: '4 road',
				jcqkg5: '5 road',
				jcqkg6: '6 road',
				jcqkg7: '7 road',
				jcqkg8: '8 road'
			},
			setHLZR: {
				todaySeconds: 'Time',
				time: 'Time (minutes)',
				keepTime: 'Time (minutes)',
				group: {
					0: '',
					1: ' group',
					2: ' road'
				},
				zl: 'Main brightness',
				zs: 'Main color temperature',
				fl: 'Sub brightness',
				fs: 'Sub color temperature',
				ld: 'Linkage brightness',
				ll: 'Linkage brightness',
				jcqkg1: '1 road',
				jcqkg2: '2 road',
				jcqkg3: '3 road',
				jcqkg4: '4 road',
				jcqkg5: '5 road',
				jcqkg6: '6 road',
				jcqkg7: '7 road',
				jcqkg8: '8 road'
			},
			setHlfdtg: {
				lux: 'Light Threshold',
				tgv: 'Dimming Level',
				switch:'Switch',
				luxMax: 'Above Lux Threshold',
				luxMin: 'Below Lux Threshold',
				group: {
					0: '',
					1: 'Paragraph',
				},
			},
			setWarnsafe:{
				checkdelay: 'Detect Time (s)',
				hotup: 'Max Temp (°C)',
				hotdown: 'Min Temp (°C)',
				hotreturn: 'Hysteresis (°C)',
				enloop: 'Enable Loop'
			},
			setSxjlxs: {
				groupList: {
					0: "Three phase voltage measurement coefficient",
					1: "Three phase current measurement coefficient",
					2: "Three phase power metering coefficient",
				},
				labelList: {
					A: 'Phase A:',
					B: 'Phase B:',
					C: 'Phase C:',
				},
				labelList2: {
					A: 'Phase A',
					B: 'Phase B',
					C: 'Phase C',
				},
				singleLamp: {
					vjl: "Voltage",
					zijl: "Main light current",
					fijl: "Auxiliary light current",
					zpjl: "Main light power",
					fpjl: "Auxiliary light power",
				}
			},
			batchIPP: {
				hs: 'Heartbeat time',
				ip: 'IP',
				port: 'Port'
			},
			setLxzq: {
				lxzq: 'Polling cycle (minutes)'
			},
			setJzqckg: {
				jzqczkg: 'switch'
			},
			tgByGroup: {
				lightTypeId: 'Lighting type'
			},
			setDDQKRBMS: {
				ddqkrbms: 'Single lamp group control daily meter mode'
			},
			setDDQKGGTG: {
				defaultL: 'Default brightness',
				defaultS: 'Default color temperature',
				tgStepNum: 'Dimming step value',
				tgMin: 'Dimming minimum value',
				tgMax: 'Dimming maximum value'
			},
			setWSGD: {
				wsgd: 'Peripheral power supply'
			},
			setGpnum: {
				lightTypeId: 'Lighting type'
			},
			setTM: {
				tm: ''
			},
			setLxkg: {
				lxkg: 'polling switch'
			},
			setWlid: {
				wlId: 'Network ID'
			},
			setLc: {
				lcs: 'Light Control Switch',
				lcov: 'Light Control On Value',
				lcrd: 'Turn-off Differential',
			},
			fotaCenterLight: {
				subSize: 'Subcontract size',
				retryNum: 'Retry count',
				intervalTime: 'Retry interval (milliseconds)',
				firmwareId: 'Upgrade firmware',
				intervalTime: 'Interval time'
			},
			wlsd: {
				port: "Port",
				account: "Account",
				password: "Password",
				key: "Permission key",
			},
			setZjid: {
				zjid: 'Master ID'
			},
			setCjid: {
				cjid: 'Slave ID'
			},
			HKSetConfigId: {
				config: "Config Name",
			},
			HKChannel: {
				channel: "Channel number",
			},
			setG: {
				pgn: "Upper Segment Device Group Number",
				tgn: "Current Segment Device Group Number",
				gn: 'Device Group Number'
			},
			setLkg: {
				lkg: 'Linkage System Operation Switch',
				to: 'Radar Timeout Time(s)'
			},
			setRC: {
				ras: 'Radar Sensitivity Adjustment',
				rcd: 'Radar Detection Direction',
				riar: 'Radar Installation Angle Compensation',
				rai: 'Radar Anti-Interference Capability Adjustment',
			},
			setAic: {
				aic: 'AI Visual Mode Configuration'
			},
			set433: {
				wc433: 'Working Channel',
				pl433: 'Power Level',
				wlid433: 'Network ID',
				ts433: 'Transmission Speed',
			},
			setRkg: {
				rkg: "Operation Switch"
			},
			setRTC: {
				rtd1: 'Moving Target Distance 1(cm)',
				rts1: 'Moving Target Sensitivity 1',
				rtd2: 'Moving Target Distance 2(cm)',
				rts2: 'Moving Target Sensitivity 2',
				rtd3: 'Moving Target Distance 3(cm)',
				rts3: 'Moving Target Sensitivity 3',
				std1: 'Static Target Distance 1(cm)',
				sts1: 'Static Target Sensitivity 1',
				std2: 'Static Target Distance 2(cm)',
				sts2: 'Static Target Sensitivity 2',
				std3: 'Static Target Distance 3(cm)',
				sts3: 'Static Target Sensitivity 3',
				dc: "Detection Capability",
				rai: "Radar anti-interference capability",
			},
			setRtp: {
				rtp: "Radar Target Hold Cycle Count(x0.1s)",
			},
			setTo: {
				to: "Radar Timeout Time(s)"
			},
			error: 'Please select the device before performing the operation',
			view: {
				tabs: {
					list: 'List',
					echart: 'Chart',
					getr: 'View daily schedule',
					view1: 'Equipment attributes',
					getJr: 'View the timing schedule',
					getZr: 'Check the on-time schedule'
				},
				nowTr: 'Currently select the day table：',
				lcs: 'Light Control Switch：',
				lcov: 'Light Control On Value：',
				lcrd: 'Turn-off Differential：',
				jwdkgt: 'Geo-Based Lighting Schedule：',
				open: 'open：',
				close: 'close：',
				tgzt: 'Dimming State：',
				getZr: 'On time schedule',
				getJr: 'Timetable',
				getGP: 'Latitude and Longitude Table',
			},
			json: {
				btnList: {
					Light: {
						jzqzhining: 'Concentrator instruction',
						kzhl: 'Control Loop',
						qkdd: 'Group control single light',
						rjl: 'Synchronous measurement coefficient',
						rd: 'Call for testing',
						lightOption: 'Dimming',
						dimLightOption: 'Dimming',
						syncTime: 'Calibrate clock',
						as: 'Read device properties',
						reb: 'Restart',
						SIM: 'Read SIM',
						batchReadIPP: 'Read network parameters',
						batchIPP: 'Set network parameters',
						setGP: 'Set latitude and longitude',
						setGPR: 'Set daily latitude/longitude table',
						syncGPR: 'Sync daily latitude/longitude table',
						setLdcs: 'Set linkage parameters',
						skhl: 'Manual control loop',
						setHlgg: 'Loop light sensing',
						setJwdpyz: 'Deviation value of lng and lat',
						setGJZQ: 'Set alarm period',
						setHgqzsb: 'Current transformer turns ratio',
						setKglsc: 'Set 3-channel switching value output',
						setSbsjzq: 'Set heartbeat cycle',
						setJzqczkg: 'Concentrator screen enable',
						syncRgj: 'Alarm parameters of synchronous equipment',
						syncJwd: 'Synchronization of local longitude and latitude parameters',
						syncRhlgg: 'Optical sensing parameters of synchronous circuit',
						setHlNb: 'Set loop year table',
						syncHlNb: 'Synchronous loop chronology',
						setHlRm: 'Loop daily meter mode',
						setHLZR: 'On time schedule setting',
						getHLZR: 'Synchronized on-time schedule',
						getSxjlxs: 'Synchronous measurement coefficient',
						setSxjlxs: 'Set measurement coefficient',
						syncDDZR: 'Synchronize group control single light on-time schedule',
						setDDZR: 'Set up a group control single light on-time schedule',
						setBmd: 'Set whitelist',
						syncBmd: 'Get whitelist',
						syncHLZR: 'Synchronous Loop Timetable',
						syncDDQKGGTG: 'Synchronize single lamp group control light sensing settings',
						setLxzq: 'Set polling cycle',
						setJzqckg: 'Enable concentrator screen settings',
						tgByGroup: 'Hand controlled group light',
						setDDQKRBMS: 'Set single lamp group control daily meter mode',
						setDDQKGGTG: 'Set single lamp group control light perception',
						setWSGD: 'Set peripheral power supply',
						reset: 'Reset device',
						setGpnum: 'Set lighting type',
						syncGpnum: 'Synchronized lighting type',
						setTM: 'Clock calibration',
						readTm: 'Read device clock',
						setLxkg: 'Set polling switch',
						syncJr: 'Synchronized Timetable',
						syncZr: 'Synchronized on-time schedule',
						setVjl: 'Set Voltage Measurement Factor',
						setIjl: 'Set Current Measurement Factor',
						setPjl: 'Set Power Measurement Factor ',
						syncDDQKJR: 'Synchronized single lamp group control timer',
						setDDQKJR: 'Set single lamp group control timer',
						setWlid: 'Set network ID',
						syncWlid: 'Synchronized network ID',
						fotaCenterLight: 'Concentrator single and double light upgrade',
						setDdldggld: 'Radar-Light Linkage Config',
						setHlfdtg: 'Adaptive Dimming Compensation',
						setWarnsafe: 'Set Rain/Snow Alarm Protection',
						setTgrbms: 'Set the dimming day watch mode',
						setTgnb: 'Set the dimming timeline',
						setTgzr: 'Set the dimming time watch',
						setTggg: 'Light sensitive dimming Settings',
						setTgbc: 'Dimming adaptive compensation',
						jzqczkg: 'Concentrator operation switch',
						syncTgnb: 'Synchronous dimming timeline',
						syncTgzr: 'Synchronous dimming time watch',
						syncTggg: 'Synchronous light sensing dimming parameters',
						async8DV: 'Synchronize 8 dimming values',
						async3SI: 'Synchronize the three switch inputs',
						async3SO: 'Synchronize the three switch outputs',
						clearCache: 'Clear instruction cache',
						setTglj: 'Set the dimming logic',
						save: 'Line protection switch',
						setTgmrv: 'Set the default dimming value',
						readE: 'Synchronous alarm Settings',
						readE1: 'Synchronize extended alarm Settings',
						setRm: 'Daily Schedule Setup',
						readLc: 'Sync Light Control',
						setLc: 'Set Light Control',
						setLcov: 'Set Light Control On Value',
						wlsd: 'Network Settings',
						setZjid: 'Set Master ID',
						setCjid: 'Set Slave ID',
						excelDownload: 'Export to Excel',
						hkSetJwd: 'Modify Lat/Long',
						HKSetConfigId: 'Modify Config',
						hksetChannel: 'Modify Channel',
						setG: 'Set Device Group Number',
						readG: 'Sync Device Group Number',
						setLkg: 'Set Linkage System Switch',
						readLkg: 'Sync Linkage System Switch',
						setRC: 'Set Radar Configuration',
						readRC: 'Sync Radar Configuration',
						setAic: 'Set AI Vision Mode Configuration',
						readAic: 'Sync AI Vision Mode Configuration',
						set433: 'Set 433 Communication Module',
						read433: 'Sync 433 Communication Module',
						readV: 'Read Device Version Information',
						setRkg: 'Set Operating Switch',
						readRkg: 'Sync Operating Switch',
						setRTC: 'Set Radar Target Detection',
						readRTC: 'Sync Radar Target Detection',
						setRtp: 'Set Radar Target Hold Cycles',
						readRtp: 'Sync Radar Target Hold Cycles',
						setTo: 'Set Radar Timeout',
						readTo: 'Sync Radar Timeout',
						option: {
							monitor: "View Monitor",
							location: "View Location",
							channel: "Modify Channel"
						}
					}
				}
			}

		},
		user: {
			status1: 'logout',
			status2: 'Enable',
			status3: 'normal',
			changeAuthority: 'change permission',
			reset: 'Reset password',
			passwordTips: 'Please enter your password',
			passwordTips2: 'Enter your password',
			drawChangePw: 'Change password',
			message: ', Preparing to log in again',
			passwordRule: 'Please enter your password again',
			passwordRule2: 'The two password inputs are inconsistent',
			searchPlaceholder: 'Please enter your system nickname',
			authority: {
				asset: 'Asset Group',
				device: 'Device/Device Asset',
				controlDevice: 'Remote Control Device',
				createWorkOrder: 'Create Work Order',
				receiveWorkOrder: 'Receive Work Order',
				strategyRule: 'Strategy Rule',
				group: 'Device group allocation',
			},
			alarm: {
				isAlarm: "Alarm SMS",
				sendTime: "Send Time",
				sendNum: "SMS Balance",
				tip: "Alert Config",
			},
			third: {
				name: 'Name',
				type: 'Type',
				parameter: 'Parameter',
				updateTime: 'UpdateTime',
				msg: 'The length range is',
			},
			media: {
				name: "Stream Name",
				type: 'Type',
				previewImg: 'Preview image',
				size: 'Size',
				createTime: 'Create Time',
			},
			tableColumn: {
				username: 'User Name',
				nickname: 'Nickname',
				createTime: 'Creation date',
				appCount: 'Total number of projects',
				devicesCount: 'Total number of devices',
				status: 'State',
				appName: 'Entry name',
				updateTime: 'Creation date',
				phone: 'Contact information'
			},
			addEditDrawer: {
				function: 'Function',
				authority: 'authority',
				readWrite: 'Read-write',
				readOnly: 'Read only',
				permit: 'permit',
				forbidden: 'forbidden',
				username: 'User Name:',
				nickname: 'Nickname:',
				userType: 'User type:',
				password: 'Password:',
				phoneCountryCode: 'Area code：',
				contactPhone: 'Contact phone:',
				devicesCount: 'Total number of devices:',
				status: 'Status:',
				rules: {
					username: 'The value ranges from 3 to 20',
					nickname: 'Please fill in the nickname',
					userType: 'Please select user type',
					password: 'Please fill in the initial password',
					passwordEdit: 'Please fill in the password change',
					phoneCountryCode: 'Please select an area code',
					contactPhone1: 'Please enter your phone number',
					contactPhone2: 'Contact information format error, please re-enter',
					contactPhone3: 'Please select an area code',
					oneMessage: 'The length is less than 20',
					userNameTwo: 'The value ranges from 12 to 30',
					passwordTwo: 'The value ranges from 8 to 20 and contains at least one letter'
				}
			}
		},
		header: {
			oldPassword: 'Old password',
			newPassword: 'New password',
			renew: 'Enter password again',
			oldPasswordRule: 'Please fill in the old password',
			newPasswordRule: 'Please fill in a new password',
			SecretKey: 'SecretKey:',
			creatTime: 'Creation time:',
			changeSecretKey: 'Change SecretKey',
			addSecretKey: 'Add SecretKey',
			changeSecretKeyTip: 'Change SecretKey? (Old SecretKey will become invalid, affecting API integration)',
			changeAfterTip: 'Note: Please copy and save the SecretKey securely. It cannot be viewed again later!',
			copySuc: 'SecretKey copy successful'
		},
		setting: {
			tableColumn: {
				jcqnb: {
					name: 'Chronological name',
					time: 'Date Range',
					['1_time']: 'Action 1',
					['2_time']: 'Action 2',
					['3_time']: 'Action 3',
					['4_time']: 'Action 4',
					text: '**When the brightness is 101, enable the optical dimming mode'
				},
				lightTypeMag: {
					groupNum: 'Group number',
					id: 'Lighting Type ID',
					lightType: 'Lighting type',
					add: 'Add lighting types'
				}
			}
		},
		energy: {
			type: 'Type',
			mode: "Time Type",
			timeType: "Time Period",
			Chart:"Chart",
			Table:"Table",
		},
		lightRate: {
			hour: 'Time Point',
			time: 'Time Range',
			tableColumn:{
				onCount: 'Lights On Count',
				offCount: 'Lights Off Count',
				onRate: 'Lights On Rate',
				offRate: 'Lights Off Rate',
				timeHour: 'Time'
			}
		},
		communication: {
			searchPlaceholder: 'Access number、ICCID、IMSI',
			btnList: {
				// balanceDisplay:'余额显示',
				// balanceRecharge:'余额充值',
				// updateData:'更新新运营商数据',
			},
			title: {
				paymentMethod: 'Payment method',
				wechat: 'wechat',
				Alipay: 'Alipay',
				totalAmount: 'Total amount',
				topUp: 'top-up'
			},
			tableColumn: {
				msisdn: 'Access number',
				iccid: 'ICCID',
				imsi: 'IMSI',
				operator: 'operator',
				orgName: 'Customer name',
				dueDate: 'Due date',
				workingCondition: 'Card status',
				lifeCycle: 'Life cycle',
				comboNameValue: "Package(MB)",
				chargeGprs: "Before recharging(MB)",
				remainGprs: 'balance(MB)',
				useGprs: 'Monthly consumption(MB)',
				totalGprs: 'Total package volume(MB)',
				comboName: 'Set meal',
				accountBalance: 'Account balance',
				waitType: 'Silent period type',
				waitDate: 'The expiration date of the silence period',
				testType: 'Test period type',
				testDate: 'Test period expiration date',
				isOrienteer: 'orientation',
				totalVoice: 'Total voice count (minutes)',
				useVoice: 'Voice usage (minutes)',
				remainVoice: 'Speech margin (minutes)',
				comboType: 'Type of package',
				customerName: 'Customer name',
			}
		}
	}
}